const Cities = [
  'Hong Kong',
  'Bangkok',
  'London',
  'Singapore',
  'Paris',
  'Dubai',
  'New York City',
  'Istanbul',
  'Mumbai',
  'Rome',
  'Tokyo',
  'Seoul',
  'Miami',
  'Moscow',
  'Munich',
  'Madrid'];

export default Cities;
